// extracted by mini-css-extract-plugin
module.exports = {"container":"_3441679","buttonContainer":"_9e4f20c","more":"_89e74cb","border":"_60e228f","licenceInfo":"_68d51d8"};